import React from 'react';
import almondMark from '../../../images/almond_mark.png';

// The Almond mark — the pixel brain from the Almond logo — as an icon. Its
// top rows are near-white, so on a light surface it sits in a small Forest
// (#06110B) chip, like an app icon; `bare` drops the chip for a surface that
// is already dark (the sidebar, a Forest avatar). Decorative: always
// aria-hidden, the host labels the control.

export const FOREST = '#06110B';

export default function AlmondMark({ size = 24, bare = false, round = false, style, ...rest }) {
  if (bare) {
    return (
      <img src={almondMark} alt="" aria-hidden="true" width={size} height={size}
        style={{ display: 'block', objectFit: 'contain', ...style }} {...rest} />
    );
  }
  const inner = Math.round(size * 0.78);
  return (
    <span
      aria-hidden="true"
      data-testid="almond-mark"
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        width: `${size}px`, height: `${size}px`, borderRadius: round ? '50%' : `${Math.max(4, Math.round(size * 0.24))}px`,
        background: FOREST, ...style,
      }}
      {...rest}
    >
      <img src={almondMark} alt="" width={inner} height={inner} style={{ display: 'block', objectFit: 'contain' }} />
    </span>
  );
}
